import listSaga from './listSaga'
import createSaga from './createSaga'
import deleteSaga from './deleteSaga'
import editSaga from './editSaga'
import oneMatchListGroupSaga from './oneMatchListGroupSaga'

const hallSaga = [listSaga(), createSaga(), deleteSaga(), editSaga(), oneMatchListGroupSaga()]

export default hallSaga
